var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "callout",
    {
      staticClass: "mb-3",
      attrs: { "border-color": "secondary-22", "has-toggle": false }
    },
    [
      _c(
        "div",
        { staticClass: "recommendation-container" },
        [
          _c("section-title", {
            staticClass: "mb-3 recommendation-container__section-title",
            attrs: {
              "container-class":
                "recommendation-container__section-title__container",
              icon: "fas fa-flag-alt",
              title: _vm.proposalRequestStatus.title,
              "title-class": "recommendation-container__section-title__info"
            }
          }),
          _c(
            "div",
            { staticClass: "align-items-center" },
            [
              _c("validation-observer", { ref: "recommendEvaluation" }, [
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                staticClass: "dropdown",
                                attrs: {
                                  clearable: false,
                                  "custom-error-msg":
                                    "Favor seleccionar la recomendación.",
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  options: _vm.options,
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.selectedStatusId,
                                  callback: function($$v) {
                                    _vm.selectedStatusId = $$v
                                  },
                                  expression: "selectedStatusId"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm.showComment
                  ? _c(
                      "div",
                      { staticClass: "mr-md-4" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El comentario es requerido.",
                                        error: errors[0],
                                        label: "Razón:",
                                        maxlength: 3000,
                                        placeholder: "Comentario",
                                        "show-char-count": ""
                                      },
                                      model: {
                                        value: _vm.comment,
                                        callback: function($$v) {
                                          _vm.comment = $$v
                                        },
                                        expression: "comment"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1949412902
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end pr-md-4" },
                [
                  _c(
                    "action-button",
                    {
                      attrs: {
                        id: "modal-btn-cancelar",
                        i: "fas fa-times-circle",
                        variant: "outline-danger mr-3"
                      },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "action-button",
                    {
                      attrs: { i: "fa fa-save", variant: "success px-3" },
                      on: { click: _vm.changeProposalStatus }
                    },
                    [_vm._v(" Guardar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }